$shm_showcase_demo_tree $shm_tree
	roots / \Компоненты
	children* <= items* /
